require('./angular-aria');
module.exports = 'ngAria';



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-aria/index.js
// module id = 226
// module chunks = 6